import { useEffect, useState, useRef } from "react";

const TIMER_MINUTES = 10;
const TIMER_SECONDS = 0;
const SECONDS_IN_MINUTE = 60;

export function useCartTimer() {
  const [cartTimer, setCartTimer] = useState(
    TIMER_MINUTES * SECONDS_IN_MINUTE + TIMER_SECONDS,
  );
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    if (cartTimer <= 0) return;
    timerRef.current = setTimeout(() => {
      setCartTimer((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [cartTimer]);

  const formatCartTimer = (seconds: number) => {
    const m = Math.floor(seconds / 60)
      .toString()
      .padStart(1, "0");
    const s = (seconds % 60).toString().padStart(2, "0");
    return `${m}:${s}`;
  };

  return {
    cartTimer,
    formatCartTimer: () => formatCartTimer(cartTimer),
  };
}
